<template>
    <div>
      <Bestsell_product/>
    </div>
  </template>
  
  <script>
  import Bestsell_product from "@/components/adminArin/pos_system/warehouse/warehouse_all/Bestsell_product";
  export default {
    name: "Bestsellproduct",
    components: {
      Bestsell_product
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  